
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './locales';
import {ErrorBoundary} from "./components/errorBoundary/ErrorBoundary";
import {isEmbedded} from "./utils/embed";


// Меню встроено в чужой сайт через iframe: гасим scroll chaining наружу, иначе
// доскролл до края уводит жест в документ-хост и тот делает pull-to-refresh.
// В standalone-режиме (открыли по QR / прямой ссылке) pull-to-refresh остаётся.
if (isEmbedded()) {
    document.documentElement.classList.add('embedded');
}

ReactDOM.render(
  <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);
